let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6chIU")).then(() => parcelRequire('dHrmQ'));